import { render, staticRenderFns } from "./AssignmentDetail.vue?vue&type=template&id=30c5479a&scoped=true&"
import script from "./AssignmentDetail.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDetail.vue?vue&type=style&index=0&id=30c5479a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c5479a",
  null
  
)

export default component.exports